import { api } from '~/redux/api/createApi';

export const useGetESignatureQueries = (isV2Enable: boolean) => {
  const {
    data: integrationV1,
    isLoading: isV1Loading,
    error: v1Error,
    refetch: refetchV1,
  } = api.endpoints.getESignatureIntegrationsV1.useQuery(undefined, {
    skip: isV2Enable,
  });

  const {
    data: vendors,
    isLoading: isProvidersLoading,
    error: providersError,
    refetch: refetchVendors,
  } = api.endpoints.getESignatureProviders.useQuery(undefined, {
    skip: !isV2Enable,
  });

  const {
    data: integrations,
    isLoading: isIntegrationsLoading,
    error: integrationsError,
    refetch: refetchIntegrations,
  } = api.endpoints.getEsignatureIntegrations.useQuery(undefined, {
    skip: !isV2Enable,
  });

  const isLoading = isV2Enable
    ? isProvidersLoading || isIntegrationsLoading
    : isV1Loading;

  const error = isV2Enable ? providersError || integrationsError : v1Error;

  const refetch = () => {
    if (isV2Enable) {
      refetchVendors();
      refetchIntegrations();
    } else {
      refetchV1();
    }
  };

  return {
    integrationV1,
    vendors,
    integrations,
    isLoading,
    error,
    refetch,
  };
};
